import SideBarTypes from './constants'

export const SidebarRequest = (postData) => {  
  return {
    type: SideBarTypes.REQUESTING,
    payload: postData,
  }
}

export const SidebarRequestSuccess = (data) => {
  return {
    type: SideBarTypes.SUCCESS,
    payload: data,
  }
}

export const SidebarRequestError = (error) => {
  return {
    type: SideBarTypes.ERROR,
    payload: error,
  }
}


// WEBPACK FOOTER //
// ./src/components/Sidebar/actions.js